import React, { useState, useEffect } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import Pagetitle from "../elements/Pagetitle";
import Portfolio from "../elements/Portfolio";

const filters = [
  {
    id: 1,
    text: "projects",
  },
  {
    id: 2,
    text: "fullstack",
  },
  {
    id: 3,
    text: "crypto",
  },
  {
    id: 4,
    text: "game",
  },
];

const allData = [
  {
    id: 1,
    title: "ApolloSignal",
    category: "fullstack",
    image: "images/works/apollosignal.png",
    description:
      "Get the latest crypto trade signals from six different exchanges.",
    popupLink: ["images/works/1.svg"],
    video: "RJIEG8Sp2gk",
    framework: "unity",
    technologies: ["ec2", "redis"],
  },
  {
    id: 2,
    title: "Dungeon Project",
    category: "game",
    image: "images/works/dungeonproject.png",
    description:
      "Select a player, upgrade your weapon, and explore the dungeon collecting gold and fight the monster guarding a chest of gold.",
    popupLink: [
      "images/works/2.svg",
      "images/works/5.svg",
      "images/works/6.svg",
    ],
    video: "iArjvxvMdjI",
    framework: "unity",
    technologies: [],
  },
  {
    id: 3,
    title: "Coin Fund",
    category: "crypto",
    image: "images/works/coinfund.png",
    description: "An easy cryptocurrency crowd funding site.",
    popupLink: ["https://www.youtube.com/watch?v=qf9z4ulfmYw"],
    video: "iVwZJkjlMDw",
    framework: "react",
    gitHub: null,
    technologies: [],
  },
  {
    id: 4,
    title: "Rainy Day",
    category: "fullstack",
    image: "images/works/rainyday.png",
    description: "File a claim in three simple steps with rainy day insurance.",
    popupLink: [
      "https://www.youtube.com/watch?v=URVHRhBSjj8",
      "https://www.youtube.com/watch?v=qf9z4ulfmYw",
    ],
    video: "zAmtyga_voQ",
    framework: "unity",
    technologies: ["cognito", "dynamodb"],
  },
  {
    id: 5,
    title: "Tetris Defender",
    category: "game",
    image: "images/works/tetrisdefender.png",
    description:
      "A hostile force is shooting at your planet. Use tetris shapes to protect your planet from hostile invaders.",
    popupLink: ["images/works/5.svg"],
    video: "l3mVmtcgbz0",
    framework: "unity",
    technologies: [],
  },
  {
    id: 6,
    title: "MiMenu",
    category: "game",
    image: "images/blog/1-1.jpg",
    description:
      "A hospital menu system that supports three different types of users: patients, providers, administrators",
    popupLink: ["images/works/5.svg"],
    gitHub: "https://github.com/DeveloperPawel/friendly-octo-adventure",
    framework: "react",
    technologies: [],
  },
  {
    id: 7,
    title: "Project: Ultimate Racer",
    category: "game",
    image: "images/works/racer.jpg",
    description:
      "Pick a car and race your enemies, use ability pickup around the map to gain the upper hand.",
    popupLink: ["images/works/5.svg"],
    video: null,
    framework: "unity",
    dDocument:
      "https://www.mediafire.com/file/g6xi1jm6yqact8l/UltimateRacer.pdf/file",
    technologies: [],
  },
];

function Works() {
  const [getAllItems] = useState(allData);
  const [dataVisibleCount, setDataVisibleCount] = useState(6);
  const [dataIncrement] = useState(3);
  const [activeFilter, setActiveFilter] = useState("");
  const [visibleItems, setVisibleItems] = useState([]);
  const [noMorePost, setNoMorePost] = useState(false);

  useEffect(() => {
    setActiveFilter(filters[0].text.toLowerCase());
    setVisibleItems(getAllItems.filter((item) => item.id <= 6));
  }, [getAllItems]);

  const handleChange = (e) => {
    e.preventDefault();
    setActiveFilter(e.target.textContent.toLowerCase());
    let tempData;
    if (e.target.textContent.toLowerCase() === filters[0].text.toLowerCase()) {
      tempData = getAllItems.filter((data) => data.id <= dataVisibleCount);
    } else {
      tempData = getAllItems.filter(
        (data) =>
          data.category === e.target.textContent.toLowerCase() &&
          data.id <= dataVisibleCount
      );
    }
    setVisibleItems(tempData);
  };

  const handleLoadmore = (e) => {
    e.preventDefault();
    let tempCount = dataVisibleCount + dataIncrement;
    if (dataVisibleCount > getAllItems.length) {
      setNoMorePost(true);
    } else {
      setDataVisibleCount(tempCount);
      if (activeFilter === filters[0].text.toLowerCase()) {
        console.log("they are same");
        setVisibleItems(getAllItems.filter((data) => data.id <= tempCount));
      } else {
        setVisibleItems(
          getAllItems.filter(
            (data) => data.category === activeFilter && data.id <= tempCount
          )
        );
      }
    }
  };

  return (
    <section id="works">
      <div className="container">
        <Pagetitle title="Recent Works" />
        {/* Start Portfolio Filters */}
        <ScrollAnimation
          animateIn="fadeInUp"
          animateOut="fadeInOut"
          animateOnce={true}
        >
          <ul className="portfolio-filter list-inline">
            {filters.map((filter) => (
              <li className="list-inline-item" key={filter.id}>
                <button
                  onClick={handleChange}
                  className={
                    filter.text.toLowerCase() === activeFilter
                      ? "text-capitalize current"
                      : "text-capitalize"
                  }
                >
                  {filter.text}
                </button>
              </li>
            ))}
          </ul>
        </ScrollAnimation>
        {/* End Portfolio Filters */}

        {/* Start Portfolio Items */}
        <div className="row portfolio-wrapper">
          {visibleItems.map((item) => (
            <div className="col-md-4 col-sm-6 grid-item" key={item.id}>
              <Portfolio portfolio={item} />
            </div>
          ))}
        </div>
        {/* End Portfolio Items */}

        <div className="load-more text-center mt-4">
          <button
            className="btn btn-default"
            onClick={handleLoadmore}
            disabled={noMorePost ? "disabled" : null}
          >
            {noMorePost ? (
              "No more items"
            ) : (
              <span>
                <i className="fas fa-spinner"></i> Load more
              </span>
            )}
          </button>
        </div>
      </div>
    </section>
  );
}

export default Works;
